// @flow strict
import { useStaticQuery, graphql } from 'gatsby';

const authorDetails = () => {
  const data = useStaticQuery(graphql`
    {allMarkdownRemark(filter: {frontmatter: {author_page: {eq: true}}}) {
      edges {
        node {
          frontmatter {
            author_page
            title
            post_count
            profile_image
            reputation
          }
        }
      }
    }}
  `);
  return data.allMarkdownRemark.edges;
};

export default authorDetails;
